/**
 * Card 4 — Shared Google OAuth entry helper.
 *
 * P0 2026-10-01 — Gully-owned Google OAuth (no Emergent). "Continue with
 * Google" now fetches the authorization URL from Gully's own backend
 * (GET /api/auth/google/url) and redirects the browser to Google
 * directly. Google redirects back to the pre-registered
 * https://askgully.com/api/auth/google/callback (SPA-handled), which
 * posts ?code=&state= to POST /api/auth/google/exchange.
 *
 * Reused by:
 *   · Login.jsx "Continue with Google" button
 *   · ConversationsSidebar signed-out "Sign in with Google" row
 *   · IdentitySheet (Chat.jsx) linked-account 409 recovery CTA
 *
 * `returnTo` must be a relative path on our own origin (e.g. "/chat").
 * We do NOT re-sanitize here — callers pass hard-coded literals only.
 */
import api from "./api";
import { isNative } from "./nativePlatform";

export async function startGoogleLogin(returnTo = "/chat") {
  // XX.285j — Native OAuth: use the Custom Tab / SFSafariViewController
  // flow via backend-mediated one-time ticket. Never window.location.href
  // on native (Google blocks embedded WebViews; system browser strands
  // the user outside the app).
  if (isNative()) {
    const { signInWithGoogleNative } = await import("./nativeGoogleAuth");
    return signInWithGoogleNative(returnTo);
  }
  try {
    const { data } = await api.get("/auth/google/url", {
      params: { return_to: returnTo },
    });
    if (data && data.url) {
      window.location.href = data.url;
      return;
    }
  } catch {
    // Fall through to login with error below.
  }
  window.location.href = "/login?error=google_unavailable";
}
